import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M21.384 17.752a2.108 2.108 0 0 1-.522 3.359 7.54 7.54 0 0 1-5.476.642C10.5 20.523 3.477 13.5 2.247 8.614a7.54 7.54 0 0 1 .642-5.476 2.108 2.108 0 0 1 3.359-.522L8.333 4.7a2.09 2.09 0 0 1 .445 2.328c-.186.435-.45.832-.778 1.172-2.384 2.384 5.417 10.185 7.8 7.8a3.9 3.9 0 0 1 1.173-.781 2.09 2.09 0 0 1 2.328.445z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }